import { type FC } from "react";
import { useFlags } from "../../../server/optimizely";
import { ApplicationLayout } from "./application-layout";
import { Layout } from "./layout";

export const MomentFormLayout: FC = () => {
  const {
    flags: { full_screen_moment_form },
    flagsLoaded,
  } = useFlags("full_screen_moment_form");

  if (!flagsLoaded) return null;

  if (full_screen_moment_form) return <ApplicationLayout />;

  return <Layout />;
};
